import { render, staticRenderFns } from "./RecordPlayer.vue?vue&type=template&id=4270d3df"
import script from "./RecordPlayer.vue?vue&type=script&lang=js"
export * from "./RecordPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports